import React from 'react'
import { Redirect } from 'react-router-dom'

import dashboardRoutes from './views/dashboard/DashboardRoutes'
import dashboardAdminRoutes from './views/dashboard/DashboardAdminRoutes'
import utilitiesRoutes from './views/utilities/UtilitiesRoutes'

import chartsRoute from './views/charts/ChartsRoute'
import dragAndDropRoute from './views/Drag&Drop/DragAndDropRoute'
import logsRoute from './views/logs/ClientesRoutes'

import formsRoutes from './views/forms/FormsRoutes'
import mapRoutes from './views/map/MapRoutes'

import anunciantesRoutes from './views/anunciantes/AnunciantesRoutes'

import permissaoRoutes from './views/permissao/PermissaoRoutes'


import clientesRoutes from './views/clientes/ClientesRoutes'
import cuponsRoute from './views/cupons/CuponsRoutes'
import configuracoesRoutes from './views/configuracoes/ConfiguracoesRoutes'
import usersRoutes from './views/administracao/UsersRoutes'

import perfilRoutes from './views/perfil/PerfilRoutes'
import faqRoutes from './views/faq/FaqRoutes'

import financeiroRoutes from './views/financeiro/FinanceiroRoutes' 
import campanhasRoutes from './views/campanhas/CampanhasRoutes'

import bannersRoutes from './views/banners/BannersRoutes'
import AnunciantesAdminRoutes from './views/anunciantes/AnunciantesAdminRoutes'
import campanhasAdminRoutes from './views/campanhas/CampanhasAdminRoutes'

import profileRoutes from './views/profile/PerfilRoutes'
import userRoutes from './views/users/UserRoutes'
import relatorioRoutes from './views/relatorios/RelatoriosRoutes'

import planosRoutes from './views/planos/PlanosRoutes'

const type = localStorage.getItem('type');

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => {

            // let root = <Redirect to="/administracao/dashboard" />;
            let root = <Redirect to="/dashboard" />;

            // if(type === 'ANUNCIANTE') root = <Redirect to="/dashboard" />

            return root

        },
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const routes = [];

if (type === 'ANUNCIANTE') {
    routes.push(
        ...dashboardAdminRoutes,
        ...perfilRoutes,
        ...anunciantesRoutes,
        ...campanhasRoutes,

        ...profileRoutes,
        ...userRoutes,
        ...cuponsRoute,
        
        // INSERIR NOVAS ROTAS ACIMA DESTA LINHA
        ...redirectRoute,
        ...errorRoute,
    );
} else {
    routes.push(
        ...logsRoute,
        ...dashboardAdminRoutes,
        ...utilitiesRoutes,
        ...chartsRoute,
        // ...dragAndDropRoute,
        ...formsRoutes,
        ...mapRoutes,
        ...clientesRoutes,
        ...AnunciantesAdminRoutes,
        ...permissaoRoutes,
        ...configuracoesRoutes,
        ...perfilRoutes,
        ...faqRoutes,
        ...usersRoutes,
        ...financeiroRoutes,
        ...campanhasAdminRoutes,
        ...bannersRoutes,

        ...profileRoutes,
        ...userRoutes,
        ...relatorioRoutes,
        ...cuponsRoute,
        ...planosRoutes,
        
        // INSERIR NOVAS ROTAS ACIMA DESTA LINHA
        ...redirectRoute,
        ...errorRoute
    );
   
}

//  const routes = [
//     ...logsRoute,
//     ...dashboardAdminRoutes,
//     ...materialRoutes,
//     ...utilitiesRoutes,
//     ...chartsRoute,
//     ...dragAndDropRoute,
//     ...formsRoutes,
//     ...mapRoutes,
//     ...clientesRoutes,
//     ...anunciantesRoutes,
//     ...permissaoRoutes,
//     ...configuracoesRoutes,
//     ...perfilRoutes,
//     ...faqRoutes,
//     ...usersRoutes,
//     ...financeiroRoutes,
//     ...campanhasRoutes,
//     ...bannersRoutes,
    
//     // INSERIR NOVAS ROTAS ACIMA DESTA LINHA
//     ...redirectRoute,
//     ...cuponsRoute,
//     ...errorRoute,
// ]

export default routes
